import script from "./MenuMobileNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMobileNavbar.vue?vue&type=script&setup=true&lang=js"

import "./MenuMobileNavbar.vue?vue&type=style&index=0&id=4587ec20&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4587ec20"]])

export default __exports__